import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["dialog", "message", "confirmButton"]

  declare readonly dialogTarget: HTMLElement
  declare readonly messageTarget: HTMLElement
  declare readonly confirmButtonTarget: HTMLElement

  private pendingConfirmation: { resume: () => void } | null = null

  connect(): void {
    // Turbo의 confirm 이벤트를 가로채서 커스텀 모달 사용
    document.addEventListener("turbo:confirm", this.handleConfirm.bind(this) as EventListener)
  }

  disconnect(): void {
    document.removeEventListener("turbo:confirm", this.handleConfirm.bind(this) as EventListener)
  }

  handleConfirm(event: Event): void {
    event.preventDefault()

    const customEvent = event as CustomEvent
    const message = customEvent.detail.message
    this.pendingConfirmation = customEvent.detail

    this.messageTarget.textContent = message
    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.classList.add("flex")

    // 포커스를 확인 버튼으로
    setTimeout(() => {
      this.confirmButtonTarget.focus()
    }, 100)
  }

  confirm(): void {
    this.close()
    if (this.pendingConfirmation) {
      this.pendingConfirmation.resume()
      this.pendingConfirmation = null
    }
  }

  cancel(): void {
    this.close()
    if (this.pendingConfirmation) {
      // resume을 호출하지 않으면 취소됨
      this.pendingConfirmation = null
    }
  }

  close(): void {
    this.dialogTarget.classList.add("hidden")
    this.dialogTarget.classList.remove("flex")
  }

  // 배경 클릭 시 취소
  backdropClick(event: Event): void {
    if (event.target === this.dialogTarget) {
      this.cancel()
    }
  }

  // ESC 키로 취소
  keydown(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.cancel()
    }
  }
}
